export const addKeyValuePair = (key: string, value: string | string[], setState: any) => {
  setState((prevState: any) => {
    const newMap = new Map(prevState);
    newMap.set(key, value);
    return newMap;
  });
};

export const getValueForKey = (key: string, state: any) => {
  if (state.has(key)) {
    return state.get(key);
  }

  return [''];
};
